<!-- // top card start  -->
<div class="row">
    <div class="col-sm-12 col-lg-12">
        <mat-card class="shadow-none">
            <div class="p-30 bg-light-primary text-center cursor-pointer rounded" (click)="btnCategoryClick('')">
                <h5 class="text-primary f-w-600 m-0 f-s-16">{{systemName}}</h5>
            </div>
        </mat-card>
    </div>
</div>
<br>
<div class="row">
    @for(topcard of topcards; track topcard.color) {
    <div class="col-lg-2 col-sm-4 col-6" (click)="topcard.onClick()">
        <mat-card class="shadow-none text-center bg-light-{{ topcard.color }}  shadow-none">
            <mat-card-content class="p-32">
                <img [src]="topcard.img" alt="users" width="40" class="rounded-circle" />
                <h4 class="mat-subtitle-2 f-w-600 text-{{ topcard.color }} m-t-8">
                    {{ topcard.title }}
                </h4>
                <!-- <h6 class="m-t-4 mat-subtitle-1 f-w-600 text-{{ topcard.color }} m-t-8">
                    {{ topcard.subtitle }}
                </h6> -->
            </mat-card-content>
        </mat-card>
    </div>
    }
</div>

<!-- // top card end  -->
<div class="row">
    <div class="col-12 col-sm-6 col-lg-12">
        <app-tickets></app-tickets>
    </div>
</div>
<br>
<div class="row">
    <div class="col-lg-4">
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-12">
                <!-- <app-sales></app-sales> -->
            </div>
            <div class="col-12 col-sm-6 col-lg-12">
                <!-- <app-monthly-earnings></app-monthly-earnings> -->
            </div>
        </div>
    </div>
    <div class="col-lg-4">
    </div>
    <div class="col-lg-4">
        <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6">
                <!-- <app-projects></app-projects> -->
            </div>
            <div class="col-12">
                <!-- <app-social-card></app-social-card> -->
            </div>
        </div>
    </div>
    <div class="col-lg-4">
        <!-- <app-selling-product></app-selling-product> -->
    </div>
    <div class="col-lg-4">
        <!-- <app-weekly-stats></app-weekly-stats> -->
    </div>
    <div class="col-lg-8">
        <!-- <app-top-projects></app-top-projects> -->
    </div>
</div>